import * as BranchesConstants from './branches.constants';

export default BranchesConstants;
